import styled, { keyframes } from 'styled-components'
import MoverComponent from './mover'
import RotatorComponent from './rotator'
import ScalerComponent from './scaler'

const borderAnimation = keyframes`
    0% { background-position: 0 0, 100% 100%, 0 100%, 100% 0; }
    100% { background-position: 14px 0, calc(100% - 14px) 100%, 0 calc(100% - 14px), 100% 14px; }
`

export const Ellipsis = styled.div`
    align-items: center;
    cursor: pointer;
    display: flex;
    height: 25px;
    justify-content: center;
    left: 100%;
    position: absolute;
    top: 0;
    width: 25px;

    svg {
        display: block;
        height: 22px;
    }
`

export const Mover = styled(MoverComponent)`
    left: 0;
    position: absolute;
    top: 0;
`

export const Scaler = styled(ScalerComponent)`
    bottom: -2px;
    position: absolute;
    right: -2px;
`

export const Rotator = styled(RotatorComponent)`
    bottom: 100%;
    left: 50%;
    margin-left: -9px;
    position: absolute;
`

export const Content = styled.div`
    border-radius: inherit;
    height: 100%;
    position: relative;
    width: 100%;
`

export const Background = styled.div`
    background: linear-gradient(90deg, #fff 50%, transparent 50%), linear-gradient(90deg, #fff 50%, transparent 50%),
        linear-gradient(0deg, #fff 50%, transparent 50%), linear-gradient(0deg, #fff 50%, transparent 50%);
    background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;
    background-size: 14px 2px, 14px 2px, 2px 14px, 2px 14px;
    background-position: 0 0, 100% 100%, 0 100%, 100% 0;
    border-radius: 4px;
    height: 100%;
    left: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%;

    &:before {
        background-color: #000;
        background-image: linear-gradient(45deg, #0e0e0e 25%, transparent 25%, transparent 75%, #0e0e0e 75%),
            linear-gradient(45deg, #0e0e0e 25%, transparent 25%, transparent 75%, #0e0e0e 75%);
        background-size: 24px 24px;
        background-position: 0 0, 12px 12px;
        border-radius: inherit;
        bottom: 2px;
        content: '';
        left: 2px;
        opacity: 0.3;
        position: absolute;
        right: 2px;
        top: 2px;
    }
`

export const Container = styled.div`
    position: relative;

    &:focus,
    &[data-dragging='true'] {
        z-index: 100;
    }

    ${Background} {
        opacity: 0;
        transition: opacity 0.15s ease-out;
    }

    ${Rotator}, ${Scaler}, ${Ellipsis} {
        opacity: 0;
        transform: scale(0);
        transition: opacity 0.15s ease-out;
    }

    &:hover ${Background} {
        opacity: 1;
    }

    &:focus ${Background}, &[data-dragging='true'] ${Background} {
        animation: ${borderAnimation} 0.5s linear infinite;
        opacity: 1;
    }

    &:focus
        ${Rotator},
        &:focus
        ${Scaler},
        &:focus
        ${Ellipsis},
        &[data-dragging='true']
        ${Rotator},
        &[data-dragging='true']
        ${Scaler},
        &[data-dragging='true']
        ${Ellipsis} {
        opacity: 1;
        transform: scale(1);
        transition: opacity 0.2s ease-out, transform 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    }
`
